import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { SelectedNode } from '@connect-services/client/components/synoptic/synoptic-plan/plan-core/synoptic-plan.models';
import { SynopticPlanInteractionService } from '@connect-services/client/services/synoptic/synoptic-plan-interaction.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-bay-drawer-navigation',
    templateUrl: './bay-drawer-navigation.component.html',
})
export class BayDrawerNavigationComponent {
    public readonly drawerPosition = input.required<string>();
    public readonly drawerSize = input.required<string>();
    public readonly selectedNode = input.required<SelectedNode>();

    protected readonly drawerCount = computed<number>(() => {
        return Object.keys(this.synopticPlanInteractionService.cassettesStore()).length;
    });
    protected readonly drawerUnmaterialized = computed<string>(() => {
        return (
            parseInt(this.selectedNode().dataNode.tiroir || '0') -
            Object.keys(this.synopticPlanInteractionService.cassettesStore()).length
        ).toString();
    });
    protected readonly synopticPlanInteractionService = inject(SynopticPlanInteractionService);
}
